// test751
(751 && 0);
